import React, { forwardRef, useImperativeHandle, useState, useEffect, useContext } from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import ALoader from 'views/pages/manage/common/a-loader';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { Tooltip } from '@mui/material';
import { GridRowModes } from "@mui/x-data-grid";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
//import StatusCellComponent from "./StatusCellComponent";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { inputStyle, newBuMappingRow, newRow } from './constant';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { editCellContainerStyle } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { inputStyles, selectStyles } from '../../holidayMaster/common';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ActionsCellComponent from './ActionCellComponent';
import { validatePincode } from './utils';
import { FaCheckSquare } from 'react-icons/fa';
import { pages, regex } from '../../../../manage/common/constant';
import { RolePermissions } from 'appContext';
import { PermissionContext } from 'appContext';
import moment from 'moment';
const BranchMappingListing = forwardRef(
    ({ currentPage = 0,
        rowCount,
        dropdown,
        rows = [],
        loader,
        createHandler,
        updateHandler,
        rowForm,
        setRowForm,
        buDropdown
    }, ref) => {
        const [rowModesModel, setRowModesModel] = useState({});
        const [rowData, setRowData] = useState(rows);
        const [isValidPinCode, setIsValid] = useState(false)
        const userPermissions = RolePermissions(
            useContext(PermissionContext),
            pages["schoolMaster"]["id"]
        );
        useEffect(() => setRowData(rows), [rows]);
        const rowFormHandler = (value, key) => setRowForm((prev) => ({ ...prev, [key]: value }));

        const startEditing = async (id, form) => {
            setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
            setRowForm({ ...form, isValid: form?.isNew ? false : true });
        };

        const stopEditing = () => {
            const currForm = { ...rowForm };
            setRowModesModel((oldModel) => ({ [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true } }));
            setRowForm({});
        };

        const handleEditClick = (params) => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                startEditing(params?.id, params?.row);
            }
        };

        const handleCancelClick = async (params) => {
            if (params?.row?.isNew) {
                setRowData(rows)
                setRowForm({});
            }
            else {
                stopEditing(params?.id)
            }
        }

        const handleSaveClick = async (params) => {
            if (rowForm?.isNew) {
                await createHandler(rowForm)
            } else {
                await updateHandler(rowForm)
            }
        }

        const addNewRow = async () => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                let randomId = generateRandomId();
                let emptyRow = {
                    ...newBuMappingRow,
                    isNew: true,
                    id: randomId,
                };
                startEditing(randomId, emptyRow);
                setRowData((prev) => [emptyRow, ...prev]);
            }
        };
        useImperativeHandle(ref, () => ({
            addNewRow: addNewRow,
            startEditing: startEditing,
            stopEditing: stopEditing
        }))

        const validatePin = async (value) => {
            const p = await validatePincode(value)
            setRowForm((prev) => ({ ...prev, isValid: !!p }));
        }

        const columns = [
            new AGridColDef("bu", "BU", false)
                .setMinWidth(80)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.bu}
                            handleChange={value => {
                                setRowForm((prev) => (
                                    { ...prev, bu: value, branch: { label: value?.businessAreaDesc, value: value?.businessAreaDesc } }
                                ))
                            }}
                            items={buDropdown}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            new AGridColDef("branch", "Branch", false)
                .setMinWidth(110)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.branch}
                            handleChange={value => rowFormHandler(value, 'branch')}
                            items={dropdown?.branch}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                            isDisabled={true}
                        />
                    </div>
                )),
            new AGridColDef("type", "Type", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1.5)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.type}
                            handleChange={value => rowFormHandler(value, 'type')}
                            items={dropdown?.branchType}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            new AGridColDef("address", "Address", false)
                .setMinWidth(140)
                .editable(true)
                .setFlex(1.5)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={''}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AInput
                            placeholder="Enter"
                            value={rowForm?.address}
                            style={inputStyles}
                            handler={(value) => {
                                rowFormHandler(value, 'address')
                            }}
                        />
                    </div>
                )),
            new AGridColDef("pincode", "Pincode", false)
                .setMinWidth(50)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={''}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip> : <div>-</div>
                ))
                .renderEditCellComponent(params => (
                    <div style={editCellContainerStyle}>
                        <AInput
                            type="text"
                            value={rowForm?.pincode} // Dynamically access value
                            handler={(value) => {
                                rowFormHandler(value, 'pincode');
                                validatePin(value);


                            }}
                            maxLength={6}
                            placeholder="Enter"
                            //style={selectStyles.control}
                            rightCustomIcon={<FaCheckSquare style={{
                                color: !(rowForm?.pincode && (rowForm?.pincode).length == 6 && rowForm?.isValid) ? '#D3D3D3' : '#00B0F5', backgroundColor: '#FFF', fontSize: '20px', top: '3px', right: '5px',
                                position: "absolute",
                                bottom: "0",
                                margin: "auto 0",
                                cursor: rowForm?.pincode && (rowForm?.pincode).length == 6 ? "pointer" : "not-allowed",
                            }}
                            />}
                            regex={regex?.numeric}
                            //onClick={()=>{validatePincode(basicForm[col?.colKey])}}
                            style={inputStyle}
                        />
                    </div>
                )),
            new AGridColDef("updatedOn", "Updated On", false)
                .setMinWidth(150)
                .setFlex(1.5)
                .renderCellComponent((params) => (
                    params?.value ? <Tooltip title={`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')} by ${params?.row?.updatedBy}`}>
                        <div className={`ellipsis-text-container`}>{`${moment(params.value).format('DD-MM-YYYY')} at ${moment(params.value).format('hh:mm A')} by ${params?.row?.updatedBy}`}</div>
                    </Tooltip> : <div>-</div>
                )),
            ...(userPermissions?.includes("C") || userPermissions?.includes("U")
                ? [new AGridColDef("action", "Action", false)
                    .setMinWidth(180)
                    .setFlex(2)
                    .columnAlign('right')
                    .renderCellComponent((params) => (
                        <ActionsCellComponent
                            params={params}
                            handleEditClick={handleEditClick}
                            handleCancelClick={handleCancelClick}
                            handleSaveClick={handleSaveClick}
                            rowForm={rowForm}
                            disable={!(rowForm?.bu && rowForm?.branch && rowForm?.type && rowForm?.address && rowForm?.pincode) || !rowForm?.isValid}
                        // deleteHandler={deleteHandler}
                        />

                    ))] : [])
        ]
        return (<>
            {loader ? <ALoader position="fixed" /> :
                <ADataGrid
                    removeWrapperContainer
                    rowModesModel={rowModesModel}
                    rows={rowData || []}
                    columns={columns}
                    rowId={(row) => row?.id}
                    rowHeight={50}
                    loading={false}
                    rowCount={rowCount}
                    // nextButtonHandler={onPageChange}
                    currentPage={currentPage}
                    components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                            <NoRowOverlay message={loader ? "Loading..." : null} />
                        ),
                    }}
                    hidePagination={true}
                    sx={gridStyles}
                    autoHeight
                />
            }
        </>
        );
    })
export default BranchMappingListing